import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="schedule-navigation"
export default class extends Controller {
  static values = {
    baseUrl: String,
    currentDate: String,
    bookableType: String
  }

  static targets = ["prevDateLink", "nextDateLink", "todayLink", "sunbedTypeField"]

  connect() {
    this.updateNavigationLinks()
  }

  // Appelé quand le filtre sunbed_type change
  sunbedTypeChanged() {
    this.updateNavigationLinks()
  }

  updateNavigationLinks() {
    const currentParams = this.getCurrentParams()

    // Calculer les dates
    const currentDate = new Date(this.currentDateValue)
    const prevDate = new Date(currentDate)
    prevDate.setDate(prevDate.getDate() - 1)
    const nextDate = new Date(currentDate)
    nextDate.setDate(nextDate.getDate() + 1)
    const today = new Date()

    // Mettre à jour les liens
    if (this.hasPrevDateLinkTarget) {
      this.prevDateLinkTarget.href = this.buildUrl(this.formatDate(prevDate), currentParams)
    }

    if (this.hasNextDateLinkTarget) {
      this.nextDateLinkTarget.href = this.buildUrl(this.formatDate(nextDate), currentParams)
    }

    if (this.hasTodayLinkTarget) {
      this.todayLinkTarget.href = this.buildUrl(this.formatDate(today), currentParams)
    }
  }

  getCurrentParams() {
    const params = {}

    // Récupérer sunbed_type si on est sur les sunbeds
    if (this.bookableTypeValue === "Sunbed" && this.hasSunbedTypeFieldTarget) {
      const sunbedType = this.sunbedTypeFieldTarget.value
      if (sunbedType) {
        params.sunbed_type = sunbedType
      }
    }

    // Récupérer tag_ids depuis l'URL actuelle
    const urlParams = new URLSearchParams(window.location.search)
    const tagIds = urlParams.get('tag_ids')
    if (tagIds) {
      params.tag_ids = tagIds
    }

    return params
  }

  buildUrl(date, params) {
    const url = new URL(this.baseUrlValue, window.location.origin)
    url.searchParams.set('date', date)

    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        url.searchParams.set(key, value)
      }
    })

    return url.toString()
  }

  formatDate(date) {
    return date.toISOString().split('T')[0]
  }
}
